import { useQuery } from '@tanstack/react-query';
import { format } from 'date-fns';

import { getTeamWiseCheckInData } from '../queries/getTeamWiseCheckInData';

export const useTeamWiseCheckinsData = (
  startDate: string,
  endDate: string,
): {
  teamWiseCheckinsData: { [key: string]: { [key: string]: number } };
  teamWiseLeavesData: { [key: string]: { [key: string]: number } };
  isLoading: boolean;
  error: Error | null;
} => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['team-wise-checkins', startDate, endDate],
    queryFn: () => getTeamWiseCheckInData(startDate, endDate),
    enabled: !!startDate && !!endDate,
  });
  const teamWiseCheckinsData: { [key: string]: { [key: string]: number } } = {};
  data?.checkIns?.forEach((checkIn) => {
    // TODO: move BC Experience to separate client
    if (checkIn.team_name === 'BC Experience') {
      return;
    }
    teamWiseCheckinsData[checkIn.team_name] = {
      ...(teamWiseCheckinsData[checkIn.team_name] || {}),
      [format(new Date(checkIn.check_in_date), 'yyyy-MM-dd')]:
        checkIn.check_in_count,
    };
  });
  const teamWiseLeavesData: { [key: string]: { [key: string]: number } } = {};
  data?.leaves?.forEach((leave) => {
    if (leave.team_name === 'BC Experience') {
      return;
    }
    teamWiseLeavesData[leave.team_name] = {
      ...(teamWiseLeavesData[leave.team_name] || {}),
      [format(new Date(leave.leave_date), 'yyyy-MM-dd')]:
        leave.employees_on_leave,
    };
  });
  return { teamWiseCheckinsData, teamWiseLeavesData, isLoading, error };
};
